import { useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    Alert,
    Fade
} from '@mui/material';
import LayoutContainer from '../components/LayoutWrapper';

const OrderTrackingForm = () => {
    const [form, setForm] = useState({ orderId: '', email: '' });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Always return not found
        setSubmitted(true);
        setTimeout(() => setSubmitted(false), 5000); // auto-hide after 5s
    };

    return (
        <LayoutContainer sx={{ mt: 8, px: { xs: 2, md: 6 }, mx: 'auto' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
                Order Tracking
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
                To track your order please enter your Order ID in the box below and press the "Track" button.
                This was given to you on your receipt and in the confirmation email you should have received.
            </Typography>

            <Fade in={submitted}>
                <Alert severity="error" sx={{ mb: 3 }}>
                    Order not found. Please double-check your Order ID and Email.
                </Alert>
            </Fade>

            <Box sx={{ width: '100%' }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '100%',
                        mx: 'auto',
                    }}
                >
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                    >
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}>
                            <TextField
                                sx={{ mr: 2 }}
                                fullWidth
                                required
                                label="Order ID"
                                name="orderId"
                                placeholder="Found in your order confirmation email."
                                value={form.orderId}
                                onChange={handleChange}
                            />
                            <TextField
                                fullWidth
                                required
                                label="Billing email"
                                name="email"
                                placeholder="Email you used during checkout."
                                type="email"
                                value={form.email}
                                onChange={handleChange}
                            />
                        </Box>

                        <Box sx={{ mt: 3 }}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    bgcolor: '#216043',
                                    px: 6,
                                    py: 1.5,
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    '&:hover': {
                                        bgcolor: '#1b4d35'
                                    }
                                }}
                            >
                                TRACK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>

        </LayoutContainer>
    );
};

export default OrderTrackingForm;
